import Hammer from 'hammerjs';

let config = {
    items: '[data-carousel-item]',
    next: '.js-next',
    prev: '.js-prev',
    current: '.js-current', // Item contains current carousel position as text, it changes during carousel sliding
    thumbnails: '.js-thumbnail',
    thumbWrapper: '.js-thumbs-wrapper',
    thumbNext: '.js-thumbs-next',
    thumbPrev: '.js-thumbs-prev',
    disabledClass: 'disabled',
    advClass: 'js-adv',
    currentClass: 'current',
    invisibleCls: 'invisible',
    animationSpeed: 300,
    swipeGestureIsEnabled: true
};

export default class Carousel {
    constructor(el, options) {
        config = $.extend(config, options);

        this.$document = $(document);
        this.$window = $(window);

        this.$carousel = $(el);
        this.$items = this.$carousel.find(config.items).not(`.${config.disabledClass}`).not(`.${config.advClass}`);
        this.$next = this.$carousel.find(config.next);
        this.$prev = this.$carousel.find(config.prev);

        this.$thumbnails = this.$carousel.find(config.thumbnails);
        this.$thumbWrapper = this.$carousel.find(config.thumbWrapper);
        this.$thumbWrapperParent = this.$thumbWrapper.parent();
        this.$thumbNext = this.$carousel.find(config.thumbNext);
        this.$thumbPrev = this.$carousel.find(config.thumbPrev);

        this.index = 0;
        this.page = 0;
        this.total = this.$thumbnails.length;
        this.height = 0;
        this.swipeGestureIsEnabled = config.swipeGestureIsEnabled;

        if (this.$items.filter(`.${config.currentClass}`).length > 0) {
            this.$items.each((index, el) => {
                if ($(el).hasClass(config.currentClass)) {
                    return false;
                }
                this.index++;
            });
        }

        this.changeSelectedThumbnail();
        this.update();

        // Check if Hammer Manager has been already initialized.
        // If so, link to Hammer Manager should be stored in data('hammer') attribute
        if (this.$carousel.data('hammer')) {
            this.mc = this.$carousel.data('hammer');
        } else {
            this.mc = new Hammer.Manager(this.$carousel[0], {
                domEvents: true
            });

            this.mc.add(new Hammer.Swipe({
                direction: Hammer.DIRECTION_HORIZONTAL,
                threshold: 0
            }));

            this.$carousel.data('hammer', this.mc);
        }
    }

    /**
     * Set carousel width and height, make active item visible
     */
    resize() {
        this.$carousel.height('auto');

        // Find max height among all carousel items
        this.$items.each((index, el) => {
            if ($(el).outerHeight() > this.height) {
                this.height = $(el).outerHeight();
            }
        });

        this.$carousel.height(this.height);

        this.scrollThumbnailWrapper();

        // Update selector
        this.$items = this.$carousel.find(config.items).not(`.${config.disabledClass}`);

        if (this.index >= this.$items.length) {
            this.index = 0;
        }

        this.$items.filter(`.${config.currentClass}`).css('left', 0);
    }

    /**
     * Reset carousel state and then resize it
     */
    update() {
        this.$items
            .removeClass(config.currentClass);

        this.$items.eq(this.index).addClass(config.currentClass);

        this.resize();
    }

    /**
     * Animate carousel
     *
     * @param index
     * @param direction (optional)
     */
    slideItem(index, direction) {
        let $prev = $(this.$items[this.index]);
        let $current = $(this.$items[index]);
        let dir = direction || ((index > this.index) && (this.index < this.$items.length - 1) ? 1 : -1); // 1 is forward, -1 is backward
        let width = this.$carousel.width();

        this.index = index;

        $current.addClass(config.currentClass);
        $current.stop(true, true);
        $current.css('left', width * dir);

        $current.animate({
            left: 0
        }, config.animationSpeed);

        $prev.stop(true, true).animate({
            left: -width * dir
        }, config.animationSpeed, () => {
            if (this.index === index) {
                $prev.removeClass(config.currentClass);
            }
        });

        this.updateCurrentText($current);
        this.changeSelectedThumbnail();
        this.scrollThumbnailWrapper();
    }

    /**
     * Returns boolean value that determines if it is possible to slide carousel
     *
     * @param event
     * @returns {boolean}
     */
    isPossibleToSlideCarousel(event) {
        let $target = $(event.target);
        let targetIsOutsideCarousel = this.$carousel.find($target).length === 0 && !this.$carousel.is($target);
        let thereIsOnlySingleNonDisabledItem = this.$items.not(`.${config.disabledClass}`).length === 1;

        return !(targetIsOutsideCarousel || thereIsOnlySingleNonDisabledItem);
    }

    slideToNext(event) {
        event.preventDefault();

        if (!this.isPossibleToSlideCarousel(event)) {
            return true;
        }

        let index = (this.index < this.$items.length - 1) ? this.index + 1 : 0;

        this.slideItem(index, 1);
    }

    slideToPrev(event) {
        event.preventDefault();

        if (!this.isPossibleToSlideCarousel(event)) {
            return true;
        }

        let index = (this.index > 0) ? this.index - 1 : this.$items.length - 1;

        this.slideItem(index, -1);
    }

    thumbClick(event) {
        let target = $(event.target);
        let currentTarget = $(event.currentTarget);
        let index = currentTarget.data('gotoIndex');

        if (target.hasClass('disabled') || index === this.index) {
            return;
        }

        this.slideItem(index);
    }

    thumbPrevClick() {
        // Check if reached the beginning of the thumbs carousel
        if (this.page === 0) {
            if (this.visible === 0) {
                this.updateNumberOfVisibleItems();
            }

            // Go to the end
            this.page = Math.ceil(this.total / this.visible) - 1;

            this.$thumbWrapper.stop(false, true).animate({
                left: `-${this.$thumbWrapperParent.width() * this.page}`
            }, config.animationSpeed);

            return;
        }

        this.page--;

        this.$thumbWrapper.stop(false, true).animate({
            left: `+=${this.$thumbWrapperParent.width()}`
        }, config.animationSpeed);
    }

    thumbNextClick() {
        if (this.visible === 0) {
            this.updateNumberOfVisibleItems();
        }

        // Check if reached the end of the thumbs carousel
        if (this.page === (Math.ceil(this.total / this.visible) - 1)) {

            // Go to the beginning
            this.page = 0;

            this.$thumbWrapper.stop(false, true).animate({
                left: 0
            }, config.animationSpeed);

            return;
        }

        this.page++;

        this.$thumbWrapper.stop(false, true).animate({
            left: `-=${this.$thumbWrapperParent.width()}`
        }, config.animationSpeed);
    }

    updateNumberOfVisibleItems() {
        this.visible = Math.floor(this.$thumbWrapperParent.width() / this.$thumbnails.eq(0).width());
    }

    moveCarousel(event) {
        let $target = $(event.target);
        let $carousel = $($target.data('move-carousel'));
        let index = $target.data('move-carousel-index');

        if ($carousel.is(this.$carousel) && index >= 0) {
            this.$thumbnails.filter(`[data-goto-index="${index}"]`).trigger('click.carousel');
        }
    }

    changeSelectedThumbnail() {
        let selectedClass = 'carousel__pagination__item--is-selected';

        this.$thumbnails.removeClass(selectedClass);
        this.$thumbnails.filter(`[data-goto-index="${this.index}"]`).addClass(selectedClass);
    }

    scrollThumbnailWrapper() {
        // Calculate number of visible thumbs
        this.updateNumberOfVisibleItems();

        let isSinglePage = this.total <= this.visible;
        this.$thumbPrev.toggleClass(config.invisibleCls, isSinglePage);
        this.$thumbNext.toggleClass(config.invisibleCls, isSinglePage);

        this.page = Math.floor(this.index / this.visible) || 0;

        this.$thumbWrapper.stop(true, false).animate({
            left: `-${this.$thumbWrapperParent.width() * this.page}`
        }, config.animationSpeed);
    }

    updateCurrentText($current) {
        let index = !$current.hasClass(config.advClass) ? (this.index + 1) : this.total;
        this.$carousel.find(config.current).html(index);
    }

    setListener() {
        this.$window
            .off('orientationchange resize', '', $.proxy(this, 'resize'))
            .on('orientationchange resize', $.proxy(this, 'resize'));

        this.$document
            .off('compare:update', '', $.proxy(this, 'update'))
            .on('compare:update', $.proxy(this, 'update'))

            .off('dialog.show', '', $.proxy(this, 'update'))
            .on('dialog.show', $.proxy(this, 'update'))

            .off('click', '[data-move-carousel]', $.proxy(this, 'moveCarousel'))
            .on('click', '[data-move-carousel]', $.proxy(this, 'moveCarousel'));

        // Disable swipe event on carousel to avoid attach of multiple events
        this.$carousel.off('swipeleft swiperight');

        if (this.swipeGestureIsEnabled) {
            this.$carousel
                .on('swipeleft', $.proxy(this, 'slideToNext'))
                .on('swiperight', $.proxy(this, 'slideToPrev'));
        }

        this.$next.off('click.carousel').on('click.carousel', $.proxy(this, 'slideToNext'));
        this.$prev.off('click.carousel').on('click.carousel', $.proxy(this,'slideToPrev'));

        this.$thumbnails.off('click.carousel').on('click.carousel', $.proxy(this, 'thumbClick'));
        this.$thumbPrev.off('click.carousel').on('click.carousel', $.proxy(this, 'thumbPrevClick'));
        this.$thumbNext.off('click.carousel').on('click.carousel', $.proxy(this, 'thumbNextClick'));
    }

    init() {
        this.setListener();
    }
}
